import React from "react";
import { useTranslation } from "react-i18next";
import video from "../../assets/untitled_OYEBUa9f_compressed.mp4";
import style from "./Lesson.module.css";
const Lesson = (props) => {
  const { t } = useTranslation();
  return (
    <div className={style.Lesson}>
      {props.close === true ? (
        <video autoPlay controls width="100%">
          <source src={video} type="video/mp4" />
          Sorry, your browser doesn't support embedded videos.
        </video>
      ) : (
        <div>
          <h1>{t("lesson")}</h1>
          <p>{t("lesson2")}</p>
        </div>
      )}
    </div>
  );
};
export default Lesson;
